import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { knowledgeApi, type KnowledgeDashboard } from '../../api/knowledge';

const NAV = [
  { to: '/knowledge/editor', label: 'Knowledge Editor' },
  { to: '/knowledge/graph', label: 'Graph Viewer' },
  { to: '/knowledge/search', label: 'Semantic Search' },
  { to: '/knowledge/memory', label: 'Memory Viewer' },
  { to: '/knowledge/citations', label: 'Citation Explorer' },
  { to: '/knowledge/analytics', label: 'Knowledge Analytics' },
  { to: '/knowledge/studio', label: 'Knowledge Studio' },
];

export function KnowledgeHubPage() {
  const [dashboard, setDashboard] = useState<KnowledgeDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void knowledgeApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Knowledge Nodes', value: dashboard.total_nodes },
        { label: 'Relationships', value: dashboard.total_relationships },
        { label: 'Documents', value: dashboard.total_documents },
        { label: 'AI Memories', value: dashboard.total_memories },
        { label: 'Embeddings', value: dashboard.embeddings_indexed },
        { label: 'Searches (24h)', value: dashboard.searches_24h },
        { label: 'RAG Contexts (24h)', value: dashboard.context_packages_24h },
        { label: 'Avg Retrieval', value: `${dashboard.avg_retrieval_ms}ms` },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Knowledge Center</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
        Enterprise knowledge graph, semantic search, RAG, AI memory and vector intelligence.
      </p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => (
          <Link key={l.to} to={l.to} className="text-slate-700 hover:underline dark:text-slate-300">{l.label}</Link>
        ))}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
